module.exports = __webpack_public_path__ + "static/income_3pro.7424973a.png";